<template>
    <div class="form__group form__group--md" @click="focuscb($event)">
        <div class="form-field" :class="{ 'error': !!errors?.length }">
            <div class="form-field-prefix">
                <svg>
                    <use :href="'#' + icon"></use>
                </svg>
            </div>
            <div class="form-field-infix">
                <label :for="name">
                    {{ label }}
                    <validation-error :errors="errors" />
                </label>
                <div>
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ValidationError from '../../features/ValidationError.vue';

export default {
    name: 'FormField',
    components: {
        ValidationError
    },
    props: {
        label: {
            type: String,
            required: true
        },
        errors: {
            type: [Array, null, undefined],
            required: false
        },
        icon: {
            type: String,
            required: true
        },
        focuscb: {
            type: Function,
        },
        name: {
            type: String,
            required: true
        }
    },
}
</script>